const Faq = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <defs>
        <clipPath id="a">
          <rect
            width="18"
            height="18"
            transform="translate(-0.193)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g transform="translate(636 -4338)">
        <g transform="translate(-635.807 4338)">
          <g transform="translate(-0.193)">
            <circle cx="0.839" cy="0.839" r="0.839" transform="translate(7.749 11.858)" />
            <path d="M8.587,0a8.587,8.587,0,1,0,8.587,8.587A8.583,8.583,0,0,0,8.587,0Zm0,15.833a7.246,7.246,0,1,1,7.246-7.246A7.242,7.242,0,0,1,8.587,15.833Z" />
            <path
              d="M178.684,128.5A2.687,2.687,0,0,0,176,131.184a.671.671,0,0,0,1.342,0,1.342,1.342,0,1,1,1.342,1.342.671.671,0,0,0-.671.671v1.677a.671.671,0,0,0,1.342,0v-1.091a2.684,2.684,0,0,0-.671-5.282Z"
              transform="translate(-170.096 -124.19)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Faq;
